export enum AnalyticsProviderTypes {
  GOOGLE = 'GOOGLE',
  MIXPANEL = 'MIXPANEL',
}

export type AnalyticsProviderType = {
  type: AnalyticsProviderTypes;
  id: string;
};
